import React from "react";
import styles from "./index.module.css";
import Button from "shared/Button";
import TextInput from "shared/@forms/TextInput";
import Select from "shared/@forms/Select";
import TextArea from "shared/@forms/TextArea";
import { useAddExternalPlugin } from "./useAddExternalPlugin";
import { useAwards } from "../useAwards";

const AddPlugin = (refresh, onClose) => {
  const {
    submit,
    iboNumber,
    setIboNumber,

    losAwardId,
    setLosAwardId,

    sponsor,
    setSponsor,

    platinum,
    setPlatinum,

    emerald,
    setEmerald,

    diamond,
    setDiamond,

    wwgSignoff,
    setWwgSignoff,

    uplineSignoff,
    setUplineSignoff,

    notes,
    setNotes,
  } = useAddExternalPlugin(refresh, onClose);

  const { awards, loading, isWaiting } = useAwards();

  return (
    <>
      <form style={{ width: "500px" }}>
        <div>
          <h3>Ibo Number</h3>
          <TextInput
            value={iboNumber}
            onChange={(e) => {
              setIboNumber(e.target.value);
            }}
          />
        </div>

        <div className={styles.padding}>
          <h3>Award</h3>
          <Select
            value={losAwardId}
            onChange={(e) => {
              setLosAwardId(e.target.value);
            }}
          >
            {awards === null ? (
              <option>Loading...</option>
            ) : (
              awards.map(function (r, i) {
                return (
                  <option key={i} value={r.id}>
                    {r.wwgDesc}
                  </option>
                );
              })
            )}
          </Select>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Sponsor Ibo</h3>
            <TextInput
              className={styles.modalTextInput}
              value={sponsor}
              onChange={(e) => {
                setSponsor(e.target.value);
              }}
            />
          </div>

          <div>
            <h3>Platinum Ibo</h3>
            <TextInput
              className={styles.modalTextInput}
              value={platinum}
              onChange={(e) => {
                setPlatinum(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Emerald Ibo</h3>
            <TextInput
              className={styles.modalTextInput}
              value={emerald}
              onChange={(e) => {
                setEmerald(e.target.value);
              }}
            />
          </div>

          <div>
            <h3>Diamond Ibo</h3>
            <TextInput
              className={styles.modalTextInput}
              value={diamond}
              onChange={(e) => {
                setDiamond(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>WWG Signoff</h3>
            <TextInput
              className={styles.modalTextInput}
              value={wwgSignoff}
              onChange={(e) => {
                setWwgSignoff(e.target.value);
              }}
            />
          </div>

          <div>
            <h3>Upline Signoff</h3>
            <TextInput
              className={styles.modalTextInput}
              value={uplineSignoff}
              onChange={(e) => {
                setUplineSignoff(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.padding}>
          <h3>Notes</h3>
          <TextArea
            value={notes}
            onChange={(e) => {
              setNotes(e.target.value);
            }}
          />
        </div>

        <div className={styles.buttonRow}>
          <Button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </Button>
          <Button
            className={styles.addButton}
            onClick={(e) => {
              e.preventDefault();
              submit();
            }}
          >
            Add Plugin
          </Button>
        </div>
      </form>
    </>
  );
};
export default AddPlugin;
